// extracted by mini-css-extract-plugin
export default {"booking":"booking_booking__HEk+z","ticket":"booking_ticket__YRBdF","action":"booking_action__zfbUF","pending":"booking_pending__164cO"};